var render = function () {
  var _vm = this
  var _h = _vm.$createElement
  var _c = _vm._self._c || _h
  return _c("section", { staticClass: "section-details" }, [
    _c("header", [_vm._v(_vm._s(_vm.$t("chatbotv2.chatDetail")))]),
    _vm._v(" "),
    _c("div", { staticClass: "archives-details" }, [
      !!_vm.conversation
        ? _c("section", { staticClass: "user" }, [
            _c(
              "div",
              { staticClass: "avatar" },
              [
                _c("Avatar", {
                  staticClass: "sc-message--avatar",
                  staticStyle: { color: "white", "font-size": "15px" },
                  attrs: {
                    size: 20,
                    username: _vm.$_.get(_vm.conversation, "fullname", ""),
                  },
                }),
              ],
              1
            ),
            _vm._v(" "),
            _c("div", { staticClass: "visitorName" }, [
              _vm._v(_vm._s(_vm.$_.get(_vm.conversation, "fullname"))),
            ]),
          ])
        : _vm._e(),
      _vm._v(" "),
      !!_vm.conversation
        ? _c("section", { staticClass: "attributes" }, [
            _c("div", { staticClass: "archives-attribute" }, [
              _c("span", { staticClass: "material-icons" }, [
                _vm._v(" schedule "),
              ]),
              _vm._v(" "),
              _c(
                "div",
                {
                  attrs: {
                    "text-truncate": "",
                    "text-type": "h6",
                    "text-weight": "semi-bold",
                  },
                },
                [
                  _c(
                    "span",
                    {
                      attrs: {
                        "text-color": "default",
                        "aria-expanded": "false",
                      },
                    },
                    [_vm._v(" " + _vm._s(_vm.startDateHumanized()) + " ")]
                  ),
                ]
              ),
            ]),
            _vm._v(" "),
            _c("span", [
              _c(
                "button",
                {
                  staticClass: "userProfile",
                  on: {
                    click: function () {
                      return _vm.seeVisitorDetail()
                    },
                  },
                },
                [
                  _vm._v(
                    "\n                    " +
                      _vm._s(_vm.$t("chatbotv2.allUserDetail")) +
                      "\n                "
                  ),
                ]
              ),
            ]),
          ])
        : _vm._e(),
      _vm._v(" "),
      !!_vm.conversation ? _c("section", { staticClass: "hr" }) : _vm._e(),
      _vm._v(" "),
      !!_vm.conversation
        ? _c(
            "section",
            { staticClass: "attributes" },
            [
              _c(
                "div",
                {
                  attrs: {
                    "text-color": "default",
                    "text-weight": "semi-bold",
                    "text-type": "h5",
                  },
                },
                [_vm._v(_vm._s(_vm.$t("chatbotv2.sessionData")))]
              ),
              _vm._v(" "),
              _c("div", { staticClass: "archives-attribute" }, [
                _c("span", { staticClass: "material-icons" }, [
                  _vm._v("schema"),
                ]),
                _vm._v(" "),
                _c(
                  "div",
                  {
                    directives: [
                      {
                        name: "tippy",
                        rawName: "v-tippy",
                        value: { followCursor: true, placement: "bottom-end" },
                        expression:
                          "{ followCursor: true, placement: 'bottom-end' }",
                      },
                    ],
                    staticClass: "attribute-name",
                    attrs: { content: _vm.$t("chatbotv2.botStory") },
                  },
                  [
                    _vm._v(
                      "\n                    " +
                        _vm._s(_vm.$t("chatbotv2.botStory")) +
                        "\n                "
                    ),
                  ]
                ),
                _vm._v(" "),
                _c(
                  "div",
                  {
                    staticClass: "attribute-value link",
                    attrs: {
                      "text-truncate": "",
                      "text-type": "h6",
                      "text-weight": "semi-bold",
                    },
                  },
                  [
                    _c(
                      "a",
                      {
                        attrs: {
                          href: _vm.getStoryLink(),
                          "text-color": "link",
                          "aria-expanded": "false",
                        },
                        on: { click: _vm.gotoStory },
                      },
                      [
                        _vm._v(
                          "\n                        " +
                            _vm._s(_vm.getStoryName()) +
                            "\n                    "
                        ),
                      ]
                    ),
                  ]
                ),
              ]),
              _vm._v(" "),
              _c("div", { staticClass: "archives-attribute" }, [
                _c("span", { staticClass: "material-icons" }, [
                  _vm._v(" public "),
                ]),
                _vm._v(" "),
                _c(
                  "div",
                  {
                    directives: [
                      {
                        name: "tippy",
                        rawName: "v-tippy",
                        value: { followCursor: true, placement: "bottom-end" },
                        expression:
                          "{ followCursor: true, placement: 'bottom-end' }",
                      },
                    ],
                    staticClass: "attribute-name",
                    attrs: { content: _vm.$t("chatbotv2.integration") },
                  },
                  [
                    _vm._v(
                      "\n                    " +
                        _vm._s(_vm.$t("chatbotv2.integration")) +
                        "\n                "
                    ),
                  ]
                ),
                _vm._v(" "),
                _c("div", { staticClass: "attribute-value" }, [
                  _vm.getAttributeValue("integration") === "web"
                    ? _c(
                        "span",
                        {
                          attrs: {
                            "text-color": "default",
                            "aria-expanded": "false",
                          },
                        },
                        [
                          _vm._v(
                            _vm._s(_vm.$t("chatbotv2.supsisChatWidget")) +
                              "\n                    "
                          ),
                        ]
                      )
                    : _vm.getAttributeValue("integration") === "whatsapp"
                    ? _c(
                        "span",
                        {
                          attrs: {
                            "text-color": "default",
                            "aria-expanded": "false",
                          },
                        },
                        [
                          _vm._v(
                            "\n                        Whatsapp\n                    "
                          ),
                        ]
                      )
                    : _vm._e(),
                ]),
              ]),
              _vm._v(" "),
              _vm._l(_vm.getAttributes(), function (attr) {
                return _c(
                  "div",
                  { staticClass: "archives-attribute" },
                  [
                    _c("AttributeIconPreview", {
                      attrs: { attribute: attr.name },
                    }),
                    _vm._v(" "),
                    _c(
                      "div",
                      {
                        directives: [
                          {
                            name: "tippy",
                            rawName: "v-tippy",
                            value: {
                              followCursor: true,
                              placement: "bottom-end",
                            },
                            expression:
                              "{ followCursor: true, placement: 'bottom-end' }",
                          },
                        ],
                        staticClass: "attribute-name",
                        attrs: { content: _vm.getAttributeName(attr.name) },
                      },
                      [
                        _vm._v(
                          "\n                    " +
                            _vm._s(_vm.getAttributeName(attr.name)) +
                            "\n                "
                        ),
                      ]
                    ),
                    _vm._v(" "),
                    _c(
                      "div",
                      {
                        directives: [
                          {
                            name: "tippy",
                            rawName: "v-tippy",
                            value: {
                              followCursor: true,
                              placement: "bottom-end",
                            },
                            expression:
                              "{ followCursor: true, placement: 'bottom-end' }",
                          },
                        ],
                        staticClass: "attribute-value",
                        attrs: { content: attr.value },
                      },
                      [
                        _c(
                          "span",
                          {
                            attrs: {
                              "text-color": "default",
                              "aria-expanded": "false",
                            },
                          },
                          [_vm._v(" " + _vm._s(attr.value))]
                        ),
                      ]
                    ),
                  ],
                  1
                )
              }),
            ],
            2
          )
        : _vm._e(),
    ]),
  ])
}
var staticRenderFns = []
render._withStripped = true

export { render, staticRenderFns }